import styled from 'styled-components';

import { Card } from '../../../../../../components/v2/Card';
import colors from '../../../../../../styles/colors';
import UserProfileCard from '../../../../../components/UserProfileCard';

const StyledCard = styled(Card)`
  display: flex;
  margin: 10px 0;
  border-radius: 8px;
  background: ${colors.base.alpha};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0;
`;

const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 20px;
`;

const BottomContainer = styled.div`
  padding: 20px;
  border-top: 1px solid ${colors.shades.gamma5};
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledUserProfileCard = styled(UserProfileCard)`
  a {
    text-decoration: none;
    width: fit-content;
  }
`;

const CommentText = styled.div`
  width: 100%;
  font-size: 15px;
`;

export {
  StyledCard,
  HeaderContainer,
  StyledUserProfileCard,
  CommentText,
  TopContainer,
  BottomContainer,
};
